import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { TextKind, ValidationLimits, Validators } from '@sb/library/base';

import { FormFieldInputBaseComponent } from '../form-field-input-base.component';

@Component({
    selector: 'lib-input-text-area',
    templateUrl: './form-field-text-area.component.html',
    styleUrls: ['./form-field-text-area.component.scss']
})
export class FormFieldTextAreaComponent extends FormFieldInputBaseComponent<string | null> implements OnInit {
    @ViewChild('textareaRef', {static: true}) textareaRef!: ElementRef<HTMLElement>;

    @Input() textKind: TextKind = TextKind.Default;
    @Input() heightFitContent: boolean = true;
    @Input() override maxCharacterLength: number = ValidationLimits.TextArea.MaxLength;

    private _currHeight: number = 84;
    private _rows: number = 4;

    constructor() {
        super();
    }

    @Input()
    set rows(value: number) {
        this._rows = value;
        this._currHeight = value * 21; // 21px is the line height

        // since font-size is fixed to $font-size-base * 0.875 !important; in _form-field.scss
        // no need to set the line height a dynamic input
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.formControl.AddDefaultValidators(Validators.maxLength(this.maxCharacterLength));
    }

    ngAfterViewInit() {
        const minimumHeight = this.GetMinimumHeight();

        this.textareaRef.nativeElement.style.setProperty("height", minimumHeight + "px");
        this.textareaRef.nativeElement.style.setProperty("min-height", minimumHeight + "px");

        if (this.heightFitContent) {
            this.textareaRef.nativeElement.parentElement?.style.setProperty("max-height", "unset", "important");

            setTimeout(() => { // need to wait for the element ready then read its scroll height
                this.ResetHeight();
            });
        }

        this.viewControl.valueChanges.subscribe(value => {
            this.SetFormControlValue(value?.trim());

            if (this.heightFitContent) {
                this.ResetHeight();
            }
        })
    }

    private ResetHeight(): void {
        // Clear the previous inline constraint before measuring the content height.
        const minimumHeight = this.GetMinimumHeight();
        this.textareaRef.nativeElement.style.setProperty("height", "auto");
        this.textareaRef.nativeElement.style.setProperty("min-height", minimumHeight + "px");

        this.textareaRef.nativeElement.style.setProperty("height", Math.max(minimumHeight, this.textareaRef.nativeElement.scrollHeight) + "px");
        this.textareaRef.nativeElement.style.setProperty("min-height", Math.max(minimumHeight, parseInt(this.textareaRef.nativeElement.style.height, 10)) + "px");
    }

    private GetMinimumHeight(): number {
        const tokenHeight = Number.parseFloat(
            getComputedStyle(document.body).getPropertyValue('--sb_form-field-container_text-area_min-height').trim()
        );
        return Math.max(this._currHeight, Number.isFinite(tokenHeight) ? tokenHeight : 0);
    }

    get rows(): number {
        return this._rows;
    }
}
